module.exports = __webpack_public_path__ + "static/media/safir_plus_revenus_plaquette_commerciale.3c060601.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/spr/documents/common/safir_plus_revenus_plaquette_commerciale.pdf
// module id = 861
// module chunks = 40